if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');
        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);

      // ET Mobile Menu
      this.initEtMobileMenu();
    }

    initEtMobileMenu() {
      const menu = document.getElementById('et-mobile-menu');
      if (!menu) return;

      // Move to body so position:fixed isn't affected by any ancestor transform/contain
      document.body.appendChild(menu);

      // Hoist sub-panels to panel level so they cover the full menu (not just .et-mobile-menu__main)
      const panel = menu.querySelector('.et-mobile-menu__panel');
      menu.querySelectorAll('.et-mobile-menu__sub').forEach(sub => {
        panel.appendChild(sub);
      });

      const toggle = document.querySelector('.et-mobile-toggle');
      const overlay = menu.querySelector('.et-mobile-menu__overlay');
      const backBtns = menu.querySelectorAll('.et-mobile-menu__back');
      const parentBtns = menu.querySelectorAll('.et-mobile-menu__row--parent');

      const updateHeaderHeight = () => {
        const h = this.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--header-height', h + 'px');
      };

      const openMenu = () => {
        updateHeaderHeight();
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        document.body.classList.add('et-menu-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('et-menu-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        menu.querySelectorAll('.et-mobile-menu__sub.is-active').forEach(sub => {
          sub.classList.remove('is-active');
          sub.setAttribute('aria-hidden', 'true');
        });
      };

      const openSub = (index) => {
        const sub = document.getElementById('et-submenu-' + index);
        if (!sub) return;
        sub.classList.add('is-active');
        sub.setAttribute('aria-hidden', 'false');
      };

      const closeSub = (index) => {
        const sub = document.getElementById('et-submenu-' + index);
        if (!sub) return;
        sub.classList.remove('is-active');
        sub.setAttribute('aria-hidden', 'true');
      };

      if (toggle) toggle.addEventListener('click', () => {
        if (menu.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      if (overlay) overlay.addEventListener('click', closeMenu);

      parentBtns.forEach(btn => {
        btn.addEventListener('click', () => openSub(btn.dataset.submenu));
      });

      backBtns.forEach(btn => {
        btn.addEventListener('click', () => closeSub(btn.dataset.submenu));
      });

      document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') closeMenu();
      });

      window.addEventListener('resize', updateHeaderHeight, { passive: true });
    }


    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      const bottom = this.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-height', Math.max(bottom, 0) + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}